import React from 'react';
import styled from 'styled-components';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {Checkbox, Col, Row, Tooltip} from 'antd';
import VBQLArea from '../../views/VBQLArea';
import Button from '../../views/StyledButton';
import SchemaMenu from './SchemaMenu';
import dateProps from './dateProps';
import FieldButtons from "../../views/FieldButtons";

const DateSeperator = styled.span`
  padding: 0 15px;
  color: #9a9a9a;
`;

const DayPickerInputWrapper = styled.span`
`;

export default ({
  schemaMenuClick, schema, addWhereField,
  chooseActiveField, activeField, chooseQueryWhere, toggleUseAfterDate, tabKey,
  queryModel, chooseQueryAfterDate, toggleUseBeforeDate, chooseQueryBeforeDate,
}) => (
  <div className="date-range-pickers">
    <Tooltip title="The start date for your date range in the format YYYY-M-D. Not allowed to be earlier than 3 months.">
      <DayPickerInputWrapper>
        <span className="small-date">
          <DayPickerInput
            locale="us"
            dayPickerProps={dateProps(chooseQueryAfterDate)}
            selectedDays={queryModel.afterDate}
          />
        </span>
      </DayPickerInputWrapper>
    </Tooltip>

    <DateSeperator>to</DateSeperator>
    <Tooltip title="The end date for your date range in the format YYYY-M-D">
      <DayPickerInputWrapper>
        <span className="small-date">
          <DayPickerInput
            locale="us"
            dayPickerProps={dateProps(chooseQueryBeforeDate)}
            selectedDays={queryModel.beforeDate}
          />
        </span>
      </DayPickerInputWrapper>
    </Tooltip>
  </div>
);
